import styled from 'styled-components';

export const EmailVerifyPopWrap = styled.div(
    props => `
        width:100%;
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,0.4);
        z-index:9;
    `
);

export const EmailVerifyPopContentWrap = styled.div(
    props => `
        width: 60rem;
        display: flex;
        background-color: #fff;
        border-radius: 0.8rem;
        flex-direction: column;
        padding: 3rem;
    `
);

export const EmailVerifyPopHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-bottom: 1rem;
        justify-content: flex-end;
    `
);

export const PopBackBtn = styled.a(
    props => `
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
    `
);

export const EmailVerifyBodyWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-top:0.5rem;
        flex-direction: column;
    `
);

export const VerifyForm = styled.form(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    `
)

export const EmailVerifyBodyHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const EmailVerifyMainText = styled.h2(
    props => `
        font-size: 2.8rem;
        color: #000000;
        font-weight: 900;
    `
);

export const EmailVerifyInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
    `
);

export const EmailVerifyInfoText = styled.p(
    props => `
        font-size: 1.5rem;
        color:#000000;
    `
);

export const EmailVerifyEditBtn = styled.a(
    props => `
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
        margin-left:2rem;
    `
);

export const OptBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin: 3rem 0; 
        flex-direction: column;
    `
);

export const ErrorText = styled.span(
    props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.large.font14};
          padding-bottom: ${props.theme.spacing.base};
          text-align: ${props.theme.font.textAlign.left};
          width: 100%;
    `,
);

export const VerifyInfoText = styled.p(
    props => `
        font-size:1.2rem;
        color:rgba(0,0,0,0.8);
        padding-top: 1rem;
        
    `
)

export const OtpFooterBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        border-top: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l15} 0; 
        align-items: center;
        justify-content: flex-end;
    `
);

export const CancelBtn = styled.button(
    props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.grey.base};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `
);

export const SubmitBtn = styled.button(
    props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.blue.base};
        margin-left: ${props.theme.spacing.large.l20};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
    `
);

export const InputWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin: 1.5rem 0;
    `
)

export const CommonInput = styled.input(
    props =>`
    width: 100%;
    height: 4.2rem;
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font16};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    position: relative;
    cursor: pointer;
    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.lightc5};
      overflow: visible;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props.theme.font.large.font14};
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
    text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
`);